import { nn } from "../../../../date-fns/locale/nn.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    nn
  }
};